import React from 'react';
import { useReveal } from '../lib/useReveal';
const TOMOS = [{
  num: 'I',
  title: 'El Despertar del Canal',
  desc: 'Tu punto de partida. La historia y los fundamentos reales del Reiki. Los 5 Principios y cómo integrarlos a tu vida cotidiana. El sistema de chakras y el cuerpo energético. Las 12 posiciones del autotratamiento completo. El protocolo de los 21 días de integración.',
  change: 'pasás de "sé que existe el Reiki" a tener una práctica diaria real desde la primera semana.'
}, {
  num: 'II',
  title: 'Simbología y Distancia',
  desc: 'Los 3 símbolos sagrados del Reiki Nivel 2. Cómo activarlos y cuándo usarlos. El protocolo completo de sesión a distancia. Cómo trabajar con el tiempo y el espacio. Técnicas de programación de intención.',
  change: 'tu práctica deja de estar limitada por la presencia física — podés ayudar a alguien que está a miles de kilómetros.'
}, {
  num: 'III',
  title: 'La Maestría Espiritual',
  desc: 'El símbolo maestro Dai Ko Myo y su uso profundo. Técnicas avanzadas de trabajo energético. Cómo crear y activar rejillas de cristales. Trabajo con karma y patrones ancestrales. La integración de la maestría como camino de vida.',
  change: 'tu práctica alcanza una dimensión que muy pocos practicantes conocen.'
}, {
  num: 'IV',
  title: 'El Manual del Iniciador',
  desc: 'El protocolo completo de cada sintonización. Cómo preparar el espacio y al iniciado. La transmisión del linaje Usui. Cómo formar tus propios estudiantes con estructura y ética.',
  change: 'podés transmitir el Reiki y construir tu propia línea de estudiantes.'
}, {
  num: 'V',
  title: 'Reiki Business: Salida Laboral',
  desc: 'Cómo armar tu oferta de servicios. Cómo fijar precios con confianza. Cómo conseguir tus primeros clientes. Cómo crear paquetes y programas. Cómo construir una práctica profesional sostenible.',
  change: 'el Reiki deja de ser un hobby y se convierte en una fuente real de ingresos.'
}, {
  num: 'VI',
  title: 'Protocolos de Emergencia',
  desc: 'Qué hacer cuando alguien necesita ayuda urgente. Crisis emocional. Dolor agudo. Ataques de pánico. Duelo. Recuperación post-quirúrgica. Acompañamiento al final de la vida.',
  change: 'sabés exactamente qué hacer cuando más importa — sin improvisar.'
}];
export function HowItWorksSection() {
  const [ref1, vis1] = useReveal();
  return <section className="bg-black py-12 md:py-16 px-5 sm:px-6 border-t border-white/5" data-id="element-196">
      <div className="container mx-auto max-w-5xl" data-id="element-197">
        <div ref={ref1} className={`reveal text-center mb-8 ${vis1 ? 'is-visible' : ''}`} data-id="element-198">
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-white" data-id="element-199">
            Los 6 Tomos del Sistema
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5" data-id="element-200">
          {TOMOS.map((tomo, idx) => <div key={idx} className="bg-[#111111] border border-white/5 rounded-xl p-4 sm:p-5 flex flex-col h-full" data-id="element-201">
              <div className="flex items-center gap-3 mb-3" data-id="element-202">
                <div className="w-9 h-9 rounded-full bg-[#eab308]/10 border border-[#eab308]/30 flex items-center justify-center text-[#eab308] font-serif font-bold text-sm flex-shrink-0" data-id="element-203">
                  {tomo.num}
                </div>
                <h3 className="text-base sm:text-lg font-serif font-bold text-white leading-tight" data-id="element-204">
                  {tomo.title}
                </h3>
              </div>

              <p className="text-gray-300 text-sm leading-relaxed mb-4 flex-grow" data-id="element-205">
                {tomo.desc}
              </p>

              <div className="bg-[#0a0a0a] rounded-lg p-3 border border-white/5 mt-auto" data-id="element-206">
                <p className="text-xs sm:text-sm text-gray-200" data-id="element-207">
                  <span className="text-[#eab308] font-bold mr-1.5" data-id="element-208">
                    ✦ Lo que cambia:
                  </span>
                  {tomo.change}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}